var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.727 12 .94-.94L9.613 8l3.054-3.06-.94-.94-4 4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m7.333 12 .94-.94L5.22 8l3.053-3.06-.94-.94-4 4z"
})));
export { SvgDoubleChevronLeft as ReactComponent };
export default __webpack_public_path__ + "99b4dc74ff23d87b3f94349a8d1190ef.svg";